/* Landing/install analytics helpers — fire-and-forget events to the backend
   /api/install-analytics/event endpoint. Never blocks navigation. */

function detectPlatform() {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/Android/i.test(ua)) return "android";
  if (/Macintosh|Windows|Linux/i.test(ua)) return "desktop";
  return "other";
}

function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

/** Fire a single install-funnel event. Returns immediately. */
export function trackInstallEvent(event) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/install-analytics/event`;
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        platform: detectPlatform(),
        standalone: isStandalone(),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* noop */ }
}
